var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C5.93436 1.5 1 6.43436 1 12.5C1 18.5656 5.93436 23.5 12 23.5C18.0656 23.5 23 18.5656 23 12.5C23 6.43436 18.0656 1.5 12 1.5ZM17.2314 18.1897C17.0527 18.3684 16.818 18.4584 16.5834 18.4584C16.3487 18.4584 16.1139 18.3684 15.9353 18.1897L11.3519 13.6064C11.1796 13.4351 11.0834 13.2021 11.0834 12.9584V7C11.0834 6.4931 11.4939 6.08339 12 6.08339C12.5061 6.08339 12.9166 6.4931 12.9166 7V12.5789L17.2314 16.8936C17.5898 17.2521 17.5898 17.8313 17.2314 18.1897Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2ccff132.svg";
export { ForwardRef as ReactComponent };